import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/literacy', component: List, name: 'literacy.index'},
  {path: '/literacy/store', component: Form, name: 'literacy.store'},
  {path: '/literacy/:id', component: Form, name: 'literacy.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/literacy/routes.js